import { ref } from 'vue';

/**
 * Composable per gli eventi di aggiornamento token in tempo reale
 * Fornisce un meccanismo semplice per notificare i componenti che i token sono stati aggiornati
 * senza bisogno di uno store complesso o di una libreria come Pinia
 */

Console.log('[useTokenUpdateEvent.js] Module loading...');

// Singleton: mantiene lo stato dell'ultimo aggiornamento e una funzione callback
let lastUpdate = ref(null);
let listeners = [];

Console.log('[useTokenUpdateEvent.js] Module loaded. Listeners array initialized:', listeners.length);

export function useTokenUpdateEvent() {
  /**
   * Registra un listener per gli aggiornamenti di token
   * Il callback verrà chiamato ogni volta che triggerTokenUpdate() è invocato
   */
  const onTokenUpdate = (callback) => {
    Console.group('[useTokenUpdateEvent] Registering Listener');
    Console.log('Current listeners:', listeners.length);
    listeners.push(callback);
    Console.log('Total listeners now:', listeners.length);
    Console.groupEnd();
    
    // Ritorna una funzione per unsubscribe
    return () => {
      Console.log('[useTokenUpdateEvent] Unsubscribing listener');
      listeners = listeners.filter(l => l !== callback);
    };
  };

  /**
   * Emette un evento di aggiornamento token
   * Tipicamente chiamato da WidgetPreview quando riceve aggiornamenti dai messaggi
   */
  const triggerTokenUpdate = (tokenData) => {
    Console.group('[useTokenUpdateEvent] Trigger Token Update');
    Console.log('Data:', tokenData);
    Console.log('Number of listeners:', listeners.length);
    lastUpdate.value = { ...tokenData, updatedAt: Date.now() };
    
    // Chiama tutti i listener registrati
    listeners.forEach((callback, index) => {
      Console.group(`Listener ${index + 1}/${listeners.length}`);
      try {
        callback(tokenData);
        Console.log('Completed successfully');
      } catch (err) {
        Console.error('Error in listener:', err);
      }
      Console.groupEnd();
    });
    Console.groupEnd();
  };

  return {
    onTokenUpdate,
    triggerTokenUpdate,
    lastUpdate
  };
}
